import api from "../api"
import { TYPE_FETCHING } from "../constants"
import { validate } from "../functions"
import { LOCAL_COMPANY_ID } from "../storage"

export const getStatusApi = (params) =>
  api(`reports/measure/${params.id_measure}/status`, TYPE_FETCHING.get, params)

export const getMeasureReportApi = (params) =>
  api(`reports/measure/${params.id_measure}/info`, TYPE_FETCHING.get, params)

export const getMeasureTotalReportApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/total`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getMeasureEngagementReportApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/engagement`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getDimensionsOutcomesReportApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/engagement-outcomes`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getCompanyHasComparativeHistoryApi = () =>
  api(
    `companies/${LOCAL_COMPANY_ID()}/reports/comparative/active`,
    TYPE_FETCHING.get
  )

export const getMeditionsApi = (params = {}) =>
  api(`companies/${LOCAL_COMPANY_ID()}/measure`, TYPE_FETCHING.get, params)

export const getMeditionAvailableActionsApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.payload.measure_id}/available-actions`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getMeasureColorRangeApi = (params) =>
  api(`reports/measure/${params.measure}/color-range`, TYPE_FETCHING.get)

export const getDivisionsAvailableApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/divisions?f${params.excludeParam}`,
    TYPE_FETCHING.get,
    { id_division: paramsAux.id_division, id_segment: paramsAux.id_segment }
  )
}

export const getEvolutionMeasureApi = ({ params, endpoint }) => {
  const paramsAux = { ...params }
  delete paramsAux.idMeasure
  return api(
    `reports/measure/${params.idMeasure}/historical/evolution/chart${endpoint}`,
    TYPE_FETCHING.get
  )
}

export const getDivisionRateApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/divisions-rate/rank`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getDataEnpsApi = (params) => {
  const segmentParam = !validate.empty(params.id_segment)
    ? `&id_segment=${params.id_segment}`
    : ""
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/enps?f${segmentParam}`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getListDimensionsApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/dimensions/rank`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getDimensionsApi = (params) => {

  const segmentParam = !validate.empty(params.id_segment)
    ? `&id_segment=${params.id_segment}`
    : ""
  let url = `reports/measure/${params.id_measure}/dimensions?f${segmentParam}`
  if (
    (validate.exist(params.params) &&
    validate.exist(params.params.id_division)) || params.id_division
  ) {
    let id_division = validate.exist(params.params) &&
    validate.exist(params.params.id_division) ? params.params.id_division: params.id_division
    if (params.id_survey_type === 2) {
      url = `reports/measure/${params.id_measure}/leaders/${id_division}/dimensions?f${segmentParam}`
    } else {
      url = `reports/measure/${params.id_measure}/divisions/${id_division}/dimensions?f${segmentParam}`
    }
  }
  const paramsAux = { ...params.params }
  delete paramsAux.id_measure
  return api(url, TYPE_FETCHING.get, paramsAux)
}

export const getQuestionsApi = (params) => {
  const segmentParam = !validate.empty(params.id_segment)
    ? `&id_segment=${params.id_segment}`
    : ""
  let url = `reports/measure/${params.id_measure}/questions?f${segmentParam}`
  if (
    validate.exist(params.params) &&
    validate.exist(params.params.id_division)
  ) {
    if (params.id_survey_type === 2) {
      url = `reports/measure/${params.id_measure}/leaders/${params.params.id_division}/questions?f${segmentParam}`
    } else {
      url = `reports/measure/${params.id_measure}/divisions/${params.params.id_division}/questions?f${segmentParam}`
    }
  }
  const paramsAux = { ...params.params }
  delete paramsAux.id_measure
  return api(url, TYPE_FETCHING.get, paramsAux)
}

export const getDivisionsApi = (params) => {
  const excludeParam = params.isExclude ? "&exclude=true" : "&exclude=false"
  const segmentParam = params.id_segment
    ? `&id_segment=${params.id_segment}`
    : ""

  let url = `reports/measure/${params.id_measure}/divisions?f${excludeParam}${segmentParam}`
  if (params.is_engagement) {
    if (params.dimensionType == "Engagement") {
      url = `reports/measure/${params.id_measure}/divisions/engagement?f${excludeParam}${segmentParam}`
      if (validate.exist(params.dimension)) {
        url = `reports/measure/${params.id_measure}/dimensions/${params.dimension}/divisions?f${excludeParam}${segmentParam}`
      }
    } else if (validate.exist(params.dimension)) {
      url = `reports/measure/${params.id_measure}/dimensions/${params.dimension}/divisions?f${excludeParam}${segmentParam}`
    }
  } else if (validate.exist(params.dimension)) {
    url = `reports/measure/${params.id_measure}/dimensions/${params.dimension}/divisions?f${excludeParam}${segmentParam}`
  }
  /* if (!validRole({ role: [5] })) {
    params.params = {}
  } */
  const paramsAux = { ...params.params }
  delete paramsAux.id_measure
  return api(url, TYPE_FETCHING.get, paramsAux)
}

export const getListRanksApi = (params) => {
  const segmentParam = params.id_segment
    ? `&id_segment=${params.id_segment}`
    : ""
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/segment/rank?f${segmentParam}`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getListQuestionsApi = (params) => {
  try {
    const segmentParam = params.id_segment
      ? `&id_segment=${params.id_segment}`
      : ""
    const measureParam = params.id_measure
      ? `&id_measure=${params.id_measure}`
      : ""

    if (!validate.empty(params.id_survey) && params.id_survey !== 0) {
      return api(
        `surveys/${params.id_survey}/questions/qualitative?f${segmentParam}${measureParam}`,
        TYPE_FETCHING.get
      )
    }
  } catch (error) {}
}

export const getSentimentWordcloudApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/answers/sentiment-wordcloud`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getSentimentAnalysisAnswersApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(
    `reports/measure/${params.id_measure}/sentiment-analysis/answers`,
    TYPE_FETCHING.get,
    paramsAux
  )
}

export const getMeasureInfoApi = (params) => {
  let paramsSegment = validate.exist(params.id_segment)
    ? `&id_segment=${params.id_segment}`
    : ""

  return api(
    `reports/measure/${params.id_measure}/info?f${paramsSegment}`,
    TYPE_FETCHING.get
  )
}

export const getQualitativeAnswersApi = (params) => {
  const isLeadership = params.measure_type === 2
  let paramsRequest = {
    "filter[question]": params.question,
    "filter[division]": isLeadership ? null : params.division,
    "filter[leader]": isLeadership ? params.division : null,
    "filter[type]": params.type,
    ...params.params,
  }

  return api(
    `reports/measure/${params.id_measure}/answers`,
    TYPE_FETCHING.get,
    { ...paramsRequest }
  )
}

export const getTeamsApi = (params) => {
  const segmentParam =
    !validate.empty(params.id_segment) && params.id_segment
      ? `&id_segment=${params.id_segment}`
      : ""
  let url = `reports/measure/${params.id_measure}/leaders?f${segmentParam}`
  if (params.dimension) {
    url = `reports/measure/${params.id_measure}/dimensions/${params.dimension}/leaders?f${segmentParam}`
  }
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  return api(url, TYPE_FETCHING.get, paramsAux)
}

export const getMeasureConfigApi = (params) =>
  api(`reports/measure/${params.id_measure}/config`, TYPE_FETCHING.get)

export const putMeasureConfigApi = (params) => {
  const paramsAux = { ...params }
  delete paramsAux.id_measure
  delete paramsAux.history
  return api(
    `reports/measure/${params.id_measure}/config`,
    TYPE_FETCHING.put,
    paramsAux
  )
}

export const getListMultipleChoiceQuestionsApi = (params) => {
  const segmentParam = !validate.empty(params.id_segment)
    ? `&id_segment=${params.id_segment}`
    : ""
  let url = `reports/measure/${params.id_measure}/multiple-choice/question-answers?f${segmentParam}`
  if (
    validate.exist(params.params) &&
    validate.exist(params.params.id_division)
  ) {
    if (params.id_survey_type === 2) {
      url = `reports/measure/${params.id_measure}/multiple-choice/question-answers?f${segmentParam}`
    } else {
      url = `reports/measure/${params.id_measure}/multiple-choice/question-answers?f${segmentParam}`
    }
  }
  const paramsAux = { ...params.params }
  delete paramsAux.id_measure
  return api(url, TYPE_FETCHING.get, paramsAux)
}
